import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/auth";
import * as types from "./types";
import * as actions from "./actions";
import { clearAdminData, setAdmin } from "../../utils/Auth";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { getInitialRoute } from "../../utils/Roles";
import { setUnseenNotificationsCountRequest } from "../Notifications/actions";
import store from "..";

function* loginSaga({ payload }) {
  try {
    const response = yield call(apis.login, payload.data);
    const { UnReadNotificationsCount, IsPasswordReset } =
      response.data.Data;
    yield put(actions.loginResponse(response.data.Data));

    yield payload.rememberMe
      ? setAdmin(response.data.Data, "local")
      : setAdmin(response.data.Data, "session");

    yield put(
      setUnseenNotificationsCountRequest(UnReadNotificationsCount)
    );
    // yield setDeviceId(device_id);
    if (!IsPasswordReset) {
      sessionStorage.setItem("tempPassword", payload.data.password);
    }
    yield payload.navigate(
      IsPasswordReset ? getInitialRoute() : ROUTE_PATHS.resetPassword
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* logoutSaga({ payload }) {
  try {
    if (!!payload?.forceLogoutParams) {
      yield put(
        actions.forceLogoutRequest({
          navigate: payload.navigate,
          params: payload.forceLogoutParams
        })
      );
    } else {
      yield put(actions.loginResponse({}));
      yield clearAdminData();
    }
    // if (!payload?.forceLogoutParams) {
    //   yield put(actions.loginResponse({}));
    //   yield clearAdminData();
    // }
    /*
     * Yield clearFirebaseToken();
     * yield generateFirebaseToken();
     */
    yield payload.navigate(ROUTE_PATHS.login);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* changePasswordSaga({ payload }) {
  try {
    yield call(apis.changePassword, payload.data);
    yield showSuccessMsg("changePassword");
    yield payload.navigate(ROUTE_PATHS.admins);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* resetPasswordSaga({ payload }) {
  try {
    yield call(apis.resetPassword, payload.data);
    yield showSuccessMsg("resetPassword");

    const userData = store.getState().auth.login;
    const updatedUserDataResetPassword = {
      ...userData,
      IsPasswordReset: true
    };
    const rememberMe = !!localStorage.getItem("admin");
    yield put(actions.loginResponse(updatedUserDataResetPassword));
    yield rememberMe
      ? setAdmin(updatedUserDataResetPassword, "local")
      : setAdmin(updatedUserDataResetPassword, "session");
    yield payload.navigate(getInitialRoute());
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* isUserForcedLogoutSaga({ payload }) {
  try {
    const response = yield call(
      apis.isUserForcedLogout,
      payload.params
    );
    if (!!response.data.Data.Data) {
      yield put(
        actions.logoutRequest({
          ...payload,
          forceLogoutParams: payload.params
        })
      );
    }
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

function* forceLogoutSaga({ payload }) {
  try {
    yield call(apis.modifyIsForceLogout, payload.params);
    yield put(actions.loginResponse({}));
    yield clearAdminData();
    yield payload.navigate(ROUTE_PATHS.login);
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

export default function* AuthSagas() {
  yield takeEvery(types.LOGIN_REQUEST, loginSaga);
  yield takeEvery(types.LOGOUT_REQUEST, logoutSaga);
  yield takeEvery(types.CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeEvery(types.RESET_PASSWORD_REQUEST, resetPasswordSaga);
  yield takeEvery(
    types.IS_USER_FORCED_LOGOUT_REQUEST,
    isUserForcedLogoutSaga
  );
  yield takeEvery(types.FORCE_LOGOUT_REQUEST, forceLogoutSaga);
}
